import { render, staticRenderFns } from "./WorkflowSettings.vue?vue&type=template&id=2cc315e3&"
import script from "./WorkflowSettings.vue?vue&type=script&lang=js&"
export * from "./WorkflowSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports